import { render } from "./DashboardInstitute.vue?vue&type=template&id=3b6251db&scoped=true"
import script from "./DashboardInstitute.vue?vue&type=script&lang=js"
export * from "./DashboardInstitute.vue?vue&type=script&lang=js"

import "./DashboardInstitute.vue?vue&type=style&index=0&id=3b6251db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6251db"]])

export default __exports__